module.exports = __webpack_public_path__ + "static/media/slow_internet.d1db0a28.png";